import Proposta from "../../../model/menudesign/comandes/Proposta";

const apiUrl = process.env.REACT_APP_API_URL;
export const PostProposta = async (page: string, proposta: Proposta, id_usu_log: string) => {
    try {
        const response = await fetch(`${apiUrl}:8072/propostes/${id_usu_log}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(proposta)
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};